import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Chip,
  Collapse,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { ESettingsModelOrToolFields, ISettingsTool, IUpdateToolsPayloadDto } from 'src/types'
import { StoreIdsModal } from './store-ids-modal.component'
import { parseNamedTag } from 'src/common/utils'
import { useTranslation } from 'react-i18next'

interface IProps {
  field: ESettingsModelOrToolFields
  tools: ISettingsTool | undefined
  handleUpdateTools: (dto: IUpdateToolsPayloadDto) => void
}

export const ToolsSection = ({ tools, handleUpdateTools, field }: IProps) => {
  const [t] = useTranslation()

  const [isEditing, setIsEditing] = useState(false)
  const [openCollapse, setOpenCollapse] = useState(true)

  const [webSearchChecked, setWebSearchChecked] = useState<boolean>(tools?.web_search ?? false)
  const [fileSearchChecked, setFileSearchChecked] = useState<boolean>(tools?.file_search ?? false)

  const theme = useTheme()

  useEffect(() => {
    if (tools) {
      setWebSearchChecked(tools.web_search)
      setFileSearchChecked(tools.file_search)
    }
  }, [tools])

  const handleUpdateWebSerch = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setWebSearchChecked(checked)
    handleUpdateTools({
      field,
      tool: { web_search: checked },
    })
  }

  const handleUpdateFileSearch = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setFileSearchChecked(checked)
    handleUpdateTools({
      field,
      tool: { file_search: checked },
    })
  }

  const handleUpdateSroreIds = (vector_store_ids: ISettingsTool['vector_store_ids']) => {
    handleUpdateTools({ tool: { vector_store_ids }, field })
  }

  const handleClose = () => {
    setIsEditing(false)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',

          alignItems: 'center',
          justifyContent: 'start',
          gap: '8px',
          ml: '50px',
        }}
      >
        <Box sx={{}}>
          <Typography>{'Web Search Tool'}</Typography>
        </Box>
        <Switch
          checked={webSearchChecked}
          onChange={handleUpdateWebSerch}
          id={'web_search_tool'}
          name={'web_search_tool'}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          gap: '8px',
          ml: '50px',
        }}
      >
        <Box sx={{}}>
          <Typography>{'Use Vector Store'}</Typography>
        </Box>
        <Switch
          checked={fileSearchChecked}
          onChange={handleUpdateFileSearch}
          id={'web_search_tool'}
          name={'web_search_tool'}
        />
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'flex-start',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <IconButton onClick={() => setOpenCollapse(!openCollapse)}>
              <ExpandMoreIcon
                sx={{
                  transform: openCollapse ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              />
            </IconButton>

            <Typography
              sx={{
                fontSize: 'inherit',
                fontWeight: 'inherit',
              }}
            >
              {'Vector Store IDs'}
            </Typography>
          </Box>
          <Button variant="outlined" size="small" onClick={() => setIsEditing(true)}>
            {t('edit-button-text.v')}
          </Button>
        </Box>

        <Collapse in={openCollapse} sx={{ width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'start',
              width: '100%',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            {tools?.vector_store_ids?.map((tag, index) => {
              const { id, name } = parseNamedTag(tag)

              return (
                <Tooltip title={id}>
                  <Chip key={index} label={name} sx={{ fontWeight: 500 }} />
                </Tooltip>
              )
            })}
          </Box>
        </Collapse>
      </Box>

      <StoreIdsModal
        handleClose={handleClose}
        open={isEditing}
        initialTags={tools?.vector_store_ids || []}
        handleUpdate={handleUpdateSroreIds}
      />
    </>
  )
}
